export function AccountNumberOrIBANValidator(group) {
    if (!!group.get('bank_account_number').value || !!group.get('bank_iban_number').value) {
        return null;
    }
    group.get('bank_account_number')
        .setErrors({
        atleastOne: "You must fill at least Account Number or IBAN"
    });
}
